import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';

export interface IPatronLevelProps {
  patronLevel: number;
  className?: string;
  isHidden?: boolean;
  padForNonPatrons?: boolean;
  absoluteOverlay?: boolean;
  style?: any;
  onClick?: any;
  contentClassName?: string;
}

const PatronLevel: FC<PropsWithChildren<IPatronLevelProps>> = (props) => {
  const {
    patronLevel = 0,
    className,
    children,
    isHidden,
    padForNonPatrons,
    absoluteOverlay,
    onClick,
    contentClassName
  } = props;

  return (
    <div
      onClick={onClick}
      className={cx('patron-level', className || '')}
      style={
        absoluteOverlay
          ? {
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              zIndex: 1
            }
          : undefined
      }
    >
      <div
        className={cx(
          'patron-level-border',
          `patron-level-border--${isHidden ? 0 : patronLevel}`,
          contentClassName,
          padForNonPatrons && (isHidden || !patronLevel) ? 'patron-level-border--padding' : ''
        )}
        style={{
          ...(props.style || {}),
          ...(absoluteOverlay
            ? {
                height: '100%'
              }
            : {})
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default PatronLevel;
